//
//
//
//
//
//
var script = {
  name: 'Row',
  props: {
    gutter: Number,
    columns: {
      type: Number,
      "default": 12
    }
  },
  computed: {
    styleGeneral: function styleGeneral() {
      return this.gutter ? "--paddingVGR:".concat(this.gutter / 2, "px;--marginVGR:-").concat(this.gutter / 2, "px") : '--paddingVGR:0px;--marginVGR:0px';
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "grid-row", style: _vm.styleGeneral },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-36f7df3e_0", { source: "\n.grid-row[data-v-36f7df3e] {\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  width: calc(100% + (var(--paddingVGR) * 2));\n  margin: var(--marginVGR);\n}\n", map: {"version":3,"sources":["/home/runner/work/vue-grid-responsive/vue-grid-responsive/src/Row.vue"],"names":[],"mappings":";AA2BA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,2CAAA;EACA,wBAAA;AACA","file":"Row.vue","sourcesContent":["<template>\n  <div :style=\"styleGeneral\" class=\"grid-row\">\n    <slot />\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'Row',\n  props: {\n    gutter: Number,\n    columns: {\n      type: Number,\n      default: 12,\n    },\n  },\n  computed: {\n    styleGeneral() {\n      return this.gutter\n          ? `--paddingVGR:${this.gutter / 2}px;--marginVGR:-${this.gutter / 2}px`\n          : '--paddingVGR:0px;--marginVGR:0px';\n    }\n  },\n};\n</script>\n\n<style scoped>\n.grid-row {\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  width: calc(100% + (var(--paddingVGR) * 2));\n  margin: var(--marginVGR);\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-36f7df3e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
var script$1 = {
  name: 'Col',
  props: {
    xs: Number,
    sm: Number,
    md: Number,
    lg: Number,
    xl: Number,
    xsOffset: {
      required: false,
      type: Number
    },
    smOffset: {
      required: false,
      type: Number
    },
    mdOffset: {
      required: false,
      type: Number
    },
    lgOffset: {
      required: false,
      type: Number
    },
    xlOffset: {
      required: false,
      type: Number
    },
    order: {
      required: false,
      type: Number
    }
  },
  data: function data() {
    var styleGeneral = this.createStyleSize();

    if (this.xs || this.sm || this.md || this.lg || this.xl) {
      styleGeneral += "--colFlexVGR:0;";
    } else {
      styleGeneral = "--colFlexVGR:1;";
    }

    if (this.order || this.order === 0) {
      styleGeneral += "--orderSGR:".concat(this.order, ";");
    }

    return {
      classGeneral: "colVGR ".concat(this.createClassSize()),
      styleGeneral: styleGeneral
    };
  },
  methods: {
    getValue: function getValue(breakpoint) {
      var localColumns = this.$parent.columns;

      if (breakpoint > localColumns) {
        breakpoint = localColumns;
      }

      return breakpoint ? "".concat(breakpoint / localColumns * 100, "%") : false;
    },
    createClassSize: function createClassSize() {
      var newClass = 'grid-column colVGR-xs ';
      newClass += this.sm ? 'colVGR-sm ' : '';
      newClass += this.md ? 'colVGR-md ' : '';
      newClass += this.lg ? 'colVGR-lg ' : '';
      newClass += this.xl ? 'colVGR-xl ' : '';
      newClass += this.xsOffset ? 'colVGR-Offset-xs ' : '';
      newClass += this.smOffset ? 'colVGR-Offset-sm ' : '';
      newClass += this.mdOffset ? 'colVGR-Offset-md ' : '';
      newClass += this.lgOffset ? 'colVGR-Offset-lg ' : '';
      newClass += this.xlOffset ? 'colVGR-Offset-xl ' : '';
      return newClass;
    },
    createStyleSize: function createStyleSize() {
      var newStyle = ''; // Scale

      newStyle += this.xs ? "--xsWidthVGR:".concat(this.getValue(this.xs), "; ") : "--xsWidthVGR:100%; ";
      newStyle += this.sm ? "--smWidthVGR:".concat(this.getValue(this.sm), "; ") : '';
      newStyle += this.md ? "--mdWidthVGR:".concat(this.getValue(this.md), "; ") : '';
      newStyle += this.lg ? "--lgWidthVGR:".concat(this.getValue(this.lg), "; ") : '';
      newStyle += this.xl ? "--xlWidthVGR:".concat(this.getValue(this.xl), "; ") : ''; // Offset

      newStyle += this.xsOffset ? "--xsOffset:".concat(this.getValue(this.xsOffset), "; ") : "";
      newStyle += this.smOffset ? "--smOffset:".concat(this.getValue(this.smOffset), "; ") : '';
      newStyle += this.mdOffset ? "--mdOffset:".concat(this.getValue(this.mdOffset), "; ") : '';
      newStyle += this.lgOffset ? "--lgOffset:".concat(this.getValue(this.lgOffset), "; ") : '';
      newStyle += this.xlOffset ? "--xlOffset:".concat(this.getValue(this.xlOffset), "; ") : '';
      return newStyle;
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: _vm.classGeneral, style: _vm.styleGeneral },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-a841d3ae_0", { source: "\n.colVGR[data-v-a841d3ae] {\n  position: relative;\n  box-sizing: border-box;\n  flex-grow: var(--colFlexVGR);\n  padding: var(--paddingVGR);\n  order: var(--orderSGR);\n}\n.colVGR-xs[data-v-a841d3ae] {\n  flex-basis: var(--xsWidthVGR);\n  max-width: var(--xsWidthVGR);\n}\n.colVGR-Offset-xs[data-v-a841d3ae] {\n  margin-left: var(--xsOffset);\n}\n@media (min-width: 576px) {\n.colVGR-sm[data-v-a841d3ae] {\n    flex-basis: var(--smWidthVGR);\n    max-width: var(--smWidthVGR);\n}\n.colVGR-Offset-sm[data-v-a841d3ae] {\n    margin-left: var(--smOffset);\n}\n}\n@media (min-width: 768px) {\n.colVGR-md[data-v-a841d3ae] {\n    flex-basis: var(--mdWidthVGR);\n    max-width: var(--mdWidthVGR);\n}\n.colVGR-Offset-md[data-v-a841d3ae] {\n    margin-left: var(--mdOffset);\n}\n}\n@media (min-width: 992px) {\n.colVGR-lg[data-v-a841d3ae] {\n    flex-basis: var(--lgWidthVGR);\n    max-width: var(--lgWidthVGR);\n}\n.colVGR-Offset-lg[data-v-a841d3ae] {\n    margin-left: var(--lgOffset);\n}\n}\n@media (min-width: 1200px) {\n.colVGR-xl[data-v-a841d3ae] {\n    flex-basis: var(--xlWidthVGR);\n    max-width: var(--xlWidthVGR);\n}\n.colVGR-Offset-xl[data-v-a841d3ae] {\n    margin-left: var(--xlOffset);\n}\n}\n", map: {"version":3,"sources":["/home/runner/work/vue-grid-responsive/vue-grid-responsive/src/Column.vue"],"names":[],"mappings":";AAuHA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,0BAAA;EACA,sBAAA;AACA;AACA;EACA,6BAAA;EACA,4BAAA;AACA;AAEA;EACA,4BAAA;AACA;AAEA;AACA;IACA,6BAAA;IACA,4BAAA;AACA;AACA;IACA,4BAAA;AACA;AACA;AAEA;AACA;IACA,6BAAA;IACA,4BAAA;AACA;AACA;IACA,4BAAA;AACA;AACA;AAEA;AACA;IACA,6BAAA;IACA,4BAAA;AACA;AACA;IACA,4BAAA;AACA;AACA;AAEA;AACA;IACA,6BAAA;IACA,4BAAA;AACA;AACA;IACA,4BAAA;AACA;AACA","file":"Column.vue","sourcesContent":["<template>\n  <div :style=\"styleGeneral\" :class=\"classGeneral\">\n    <slot />\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'Col',\n  props: {\n    xs: Number,\n    sm: Number,\n    md: Number,\n    lg: Number,\n    xl: Number,\n    xsOffset: {\n      required: false,\n      type: Number\n    },\n    smOffset: {\n      required: false,\n      type: Number\n    },\n    mdOffset: {\n      required: false,\n      type: Number\n    },\n    lgOffset: {\n      required: false,\n      type: Number\n    },\n    xlOffset: {\n      required: false,\n      type: Number\n    },\n    order: {\n      required: false,\n      type: Number\n    }\n  },\n  data() {\n    let styleGeneral = this.createStyleSize();\n\n    if (this.xs || this.sm || this.md || this.lg || this.xl) {\n      styleGeneral += `--colFlexVGR:0;`;\n    } else {\n      styleGeneral = `--colFlexVGR:1;`;\n    }\n\n    if (this.order || this.order === 0) {\n      styleGeneral += `--orderSGR:${this.order};`;\n    }\n\n    return {\n      classGeneral: `colVGR ${this.createClassSize()}`,\n      styleGeneral\n    };\n  },\n  methods: {\n    getValue(breakpoint) {\n      const localColumns = this.$parent.columns;\n      if (breakpoint > localColumns) {\n        breakpoint = localColumns;\n      }\n\n      return breakpoint ? `${(breakpoint / localColumns) * 100}%` : false;\n    },\n    createClassSize() {\n      let newClass = 'grid-column colVGR-xs ';\n\n      newClass += this.sm ? 'colVGR-sm ' : '';\n      newClass += this.md ? 'colVGR-md ' : '';\n      newClass += this.lg ? 'colVGR-lg ' : '';\n      newClass += this.xl ? 'colVGR-xl ' : '';\n\n      newClass += this.xsOffset ? 'colVGR-Offset-xs ' : '';\n      newClass += this.smOffset ? 'colVGR-Offset-sm ' : '';\n      newClass += this.mdOffset ? 'colVGR-Offset-md ' : '';\n      newClass += this.lgOffset ? 'colVGR-Offset-lg ' : '';\n      newClass += this.xlOffset ? 'colVGR-Offset-xl ' : '';\n\n      return newClass;\n    },\n    createStyleSize() {\n      let newStyle = '';\n\n      // Scale\n      newStyle += this.xs\n        ? `--xsWidthVGR:${this.getValue(this.xs)}; `\n        : `--xsWidthVGR:100%; `;\n      newStyle += this.sm ? `--smWidthVGR:${this.getValue(this.sm)}; ` : '';\n      newStyle += this.md ? `--mdWidthVGR:${this.getValue(this.md)}; ` : '';\n      newStyle += this.lg ? `--lgWidthVGR:${this.getValue(this.lg)}; ` : '';\n      newStyle += this.xl ? `--xlWidthVGR:${this.getValue(this.xl)}; ` : '';\n\n      // Offset\n      newStyle += this.xsOffset\n        ? `--xsOffset:${this.getValue(this.xsOffset)}; `\n        : ``;\n      newStyle += this.smOffset\n        ? `--smOffset:${this.getValue(this.smOffset)}; `\n        : '';\n      newStyle += this.mdOffset\n        ? `--mdOffset:${this.getValue(this.mdOffset)}; `\n        : '';\n      newStyle += this.lgOffset\n        ? `--lgOffset:${this.getValue(this.lgOffset)}; `\n        : '';\n      newStyle += this.xlOffset\n        ? `--xlOffset:${this.getValue(this.xlOffset)}; `\n        : '';\n\n      return newStyle;\n    }\n  }\n};\n</script>\n\n<style scoped>\n.colVGR {\n  position: relative;\n  box-sizing: border-box;\n  flex-grow: var(--colFlexVGR);\n  padding: var(--paddingVGR);\n  order: var(--orderSGR);\n}\n.colVGR-xs {\n  flex-basis: var(--xsWidthVGR);\n  max-width: var(--xsWidthVGR);\n}\n\n.colVGR-Offset-xs {\n  margin-left: var(--xsOffset);\n}\n\n@media (min-width: 576px) {\n  .colVGR-sm {\n    flex-basis: var(--smWidthVGR);\n    max-width: var(--smWidthVGR);\n  }\n  .colVGR-Offset-sm {\n    margin-left: var(--smOffset);\n  }\n}\n\n@media (min-width: 768px) {\n  .colVGR-md {\n    flex-basis: var(--mdWidthVGR);\n    max-width: var(--mdWidthVGR);\n  }\n  .colVGR-Offset-md {\n    margin-left: var(--mdOffset);\n  }\n}\n\n@media (min-width: 992px) {\n  .colVGR-lg {\n    flex-basis: var(--lgWidthVGR);\n    max-width: var(--lgWidthVGR);\n  }\n  .colVGR-Offset-lg {\n    margin-left: var(--lgOffset);\n  }\n}\n\n@media (min-width: 1200px) {\n  .colVGR-xl {\n    flex-basis: var(--xlWidthVGR);\n    max-width: var(--xlWidthVGR);\n  }\n  .colVGR-Offset-xl {\n    margin-left: var(--xlOffset);\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = "data-v-a841d3ae";
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
var script$2 = {
  name: 'Hidden',
  data: function data() {
    return {
      classGeneral: "".concat(this.createClassSize())
    };
  },
  props: {
    xs: Boolean,
    sm: Boolean,
    md: Boolean,
    lg: Boolean,
    xl: Boolean
  },
  methods: {
    createClassSize: function createClassSize() {
      var newClass = '';
      newClass += this.xs ? 'hiddenVGR-xs ' : '';
      newClass += this.sm ? 'hiddenVGR-sm ' : '';
      newClass += this.md ? 'hiddenVGR-md ' : '';
      newClass += this.lg ? 'hiddenVGR-lg ' : '';
      newClass += this.xl ? 'hiddenVGR-xl ' : '';
      return newClass;
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.classGeneral }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-49725bd0_0", { source: "\n@media (max-width: 575px) {\n.hiddenVGR-xs[data-v-49725bd0] {\n    display: none;\n}\n}\n@media (min-width: 576px) and (max-width: 767px) {\n.hiddenVGR-sm[data-v-49725bd0] {\n    display: none;\n}\n}\n@media (min-width: 768px) and (max-width: 991px) {\n.hiddenVGR-md[data-v-49725bd0] {\n    display: none;\n}\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n.hiddenVGR-lg[data-v-49725bd0] {\n    display: none;\n}\n}\n@media (min-width: 1200px) {\n.hiddenVGR-xl[data-v-49725bd0] {\n    display: none;\n}\n}\n", map: {"version":3,"sources":["/home/runner/work/vue-grid-responsive/vue-grid-responsive/src/Hidden.vue"],"names":[],"mappings":";AAsCA;AACA;IACA,aAAA;AACA;AACA;AAEA;AACA;IACA,aAAA;AACA;AACA;AAEA;AACA;IACA,aAAA;AACA;AACA;AAEA;AACA;IACA,aAAA;AACA;AACA;AAEA;AACA;IACA,aAAA;AACA;AACA","file":"Hidden.vue","sourcesContent":["<template>\n  <div :class=\"classGeneral\">\n    <slot />\n  </div>\n</template>\n\n<script>\nexport default {\n  name: 'Hidden',\n  data() {\n    return {\n      classGeneral: `${this.createClassSize()}`\n    };\n  },\n  props: {\n    xs: Boolean,\n    sm: Boolean,\n    md: Boolean,\n    lg: Boolean,\n    xl: Boolean\n  },\n  methods: {\n    createClassSize() {\n      let newClass = '';\n\n      newClass += this.xs ? 'hiddenVGR-xs ' : '';\n      newClass += this.sm ? 'hiddenVGR-sm ' : '';\n      newClass += this.md ? 'hiddenVGR-md ' : '';\n      newClass += this.lg ? 'hiddenVGR-lg ' : '';\n      newClass += this.xl ? 'hiddenVGR-xl ' : '';\n\n      return newClass;\n    }\n  }\n};\n</script>\n\n<style scoped>\n@media (max-width: 575px) {\n  .hiddenVGR-xs {\n    display: none;\n  }\n}\n\n@media (min-width: 576px) and (max-width: 767px) {\n  .hiddenVGR-sm {\n    display: none;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .hiddenVGR-md {\n    display: none;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .hiddenVGR-lg {\n    display: none;\n  }\n}\n\n@media (min-width: 1200px) {\n  .hiddenVGR-xl {\n    display: none;\n  }\n}\n</style>\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = "data-v-49725bd0";
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

export { __vue_component__$1 as Column, __vue_component__$2 as Hidden, __vue_component__ as Row };
//# sourceMappingURL=vue-grid-responsive.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-grid-responsive/dist/vue-grid-responsive.esm.js
// module id = 1348
// module chunks = 3